import Button from '../Button'
import {
    LogoutIcon,
} from '../Icon'
import {
    LogoutViewProps,
} from './types'
import React from 'react'
import {useTranslation} from 'react-i18next'

const LogoutView: React.FC<LogoutViewProps> = (props: LogoutViewProps): React.ReactElement => {
    const {onClickHandler} = props
    const {t} = useTranslation()
    return (
        <Button
            color='text'
            iconLeft={LogoutIcon}
            onPress={(): void => onClickHandler()}
            text={t('Logout')}
            type='button'
        />
    )
}
export default LogoutView
